import { sentenceCase, titleCase } from '@/helpers/format';

export default {
  props: {
    titleKey: {
      type: String,
      default: 'nav_title',
    },
    containerClasses: {
      type: String,
      default: 'relative z-20 cursor-pointer transition group vetster-nav-link shadow-md flex justify-between items-center px-5 py-4 xl:py-2 bg-grimace-50',
    },
    postType: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      activeNav: '',
    };
  },

  computed: {
    params() {
      return this.postType
        ? new URLSearchParams({ 'post-type': this.postType }).toString()
        : '';
    },
  },

  methods: {
    getLabelFromAnchor(anchor) {
      return sentenceCase(anchor?.replace(/[_-]/g, ' ').replace(/#/g, ''));
    },
    getLabel(label) {
      if (this.titleKey === 'slug') {
        return titleCase(label?.replace(/-/g, ' '));
      }

      return label;
    },
  },
};
